import { ProductState } from './state';

export const initialState: ProductState = {
  products: [],
  categories: [],
  inventory: [],
};
